import type { Entity } from '../types/domain'

export const entities: Entity[] = [
  {
    id: 'en-1',
    name: 'Department of Culture & Tourism — Abu Dhabi',
    kind: 'Local Government',
    emirate: 'Abu Dhabi',
    contact: 'events@dct.gov.ae',
    bidsWon: 7,
    bidsSubmitted: 11,
    supportReceivedAed: 1_240_000_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-2',
    name: 'Dubai World Trade Centre Authority',
    kind: 'Semi-Government',
    emirate: 'Dubai',
    contact: 'bids@dwtc.com',
    bidsWon: 12,
    bidsSubmitted: 15,
    supportReceivedAed: 890_000_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-3',
    name: 'Ministry of Climate Change & Environment',
    kind: 'Federal',
    emirate: 'Federal',
    contact: 'summits@moccae.gov.ae',
    bidsWon: 4,
    bidsSubmitted: 5,
    supportReceivedAed: 2_100_000_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-4',
    name: 'UAE National Olympic Committee',
    kind: 'Federal',
    emirate: 'Federal',
    contact: 'bidoffice@uaenoc.ae',
    bidsWon: 2,
    bidsSubmitted: 6,
    supportReceivedAed: 460_000_000,
    compliance: 'under-review'
  },
  {
    id: 'en-5',
    name: 'Sharjah Investment & Development Authority',
    kind: 'Local Government',
    emirate: 'Sharjah',
    contact: 'events@shurooq.gov.ae',
    bidsWon: 3,
    bidsSubmitted: 7,
    supportReceivedAed: 150_000_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-6',
    name: 'Ras Al Khaimah Tourism Development Authority',
    kind: 'Local Government',
    emirate: 'Ras Al Khaimah',
    contact: 'programmes@raktda.com',
    bidsWon: 2,
    bidsSubmitted: 4,
    supportReceivedAed: 78_000_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-7',
    name: 'Emirates Falcon Events LLC',
    kind: 'Private Organiser',
    emirate: 'Dubai',
    contact: 'ops@falconevents.ae',
    bidsWon: 1,
    bidsSubmitted: 3,
    supportReceivedAed: 12_400_000,
    compliance: 'under-review'
  },
  {
    id: 'en-8',
    name: 'Abu Dhabi Sports Council',
    kind: 'Local Government',
    emirate: 'Abu Dhabi',
    contact: 'bids@adsc.gov.ae',
    bidsWon: 6,
    bidsSubmitted: 9,
    supportReceivedAed: 520_000_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-9',
    name: 'Ajman Chamber of Commerce & Industry',
    kind: 'Local Government',
    emirate: 'Ajman',
    contact: 'events@ajmanchamber.ae',
    bidsWon: 0,
    bidsSubmitted: 2,
    supportReceivedAed: 4_800_000,
    compliance: 'good-standing'
  },
  {
    id: 'en-10',
    name: 'Fujairah Culture & Media Authority',
    kind: 'Local Government',
    emirate: 'Fujairah',
    contact: 'culture@fujairah.ae',
    bidsWon: 1,
    bidsSubmitted: 2,
    supportReceivedAed: 9_200_000,
    compliance: 'restricted'
  }
]

export function entityById(id: string): Entity | undefined {
  return entities.find((e) => e.id === id)
}

export function entityName(id: string): string {
  return entityById(id)?.name ?? 'Unknown entity'
}
